<template lang="pug">
  .page__items.page__items--hide
    .page__item(data-id="main")
      Main
    .page__item(data-id="menu")
      Menu
    .page__item(data-id="about")
      About
    .page__item(data-id="photo-reports")
      PhotoReports
    .page__item(data-id="advertisement")
      Advertisement
    .page__item(data-id="tour")
      Tour
    .page__item(data-id="reviews")
      Reviews
    .page__item(data-id="contacts")
      Contacts
    .page__item(data-id="privacy-policy")
      PrivacyPolicy
    .page__item(data-id="restaurants")
      Restaurants
    .page__item(data-id="cart")
      Cart
    .page__item(data-id="page-404")
      Page404
    .page__item(data-id="card-payment")
      CardPayment
    .page__item(data-id="company-details")
      CompanyDetails

</template>

<script>
import EventBus from '@/eventBus';

import Main from '@/views/Main';
import Menu from '@/views/Menu';
import About from '@/views/About';
import PhotoReports from '@/views/PhotoReports';
import Advertisement from '@/views/Advertisement';
import Tour from '@/views/Tour';
import Reviews from '@/views/Reviews';
import Contacts from '@/views/Contacts';
import PrivacyPolicy from '@/views/PrivacyPolicy';
import Restaurants from '@/views/Restaurants';
import Cart from '@/views/Cart';
import Page404 from '@/views/Page404';
import CardPayment from '@/views/CardPayment';
import CompanyDetails from '@/views/CompanyDetails';

export default {
  components: {
    Main,
    Menu,
    About,
    PhotoReports,
    Advertisement,
    Tour,
    Reviews,
    Contacts,
    PrivacyPolicy,
    Restaurants,
    Cart,
    Page404,
    CardPayment,
    CompanyDetails
  },

  // Первый заход на страницу & для роутов типа /catalog/:id
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // экземпляр компонента доступен как `vm`

      let params = vm.getParams(to);

      EventBus.$emit(params.event, params);
    })
  },

  // Навигация по ссылкам
  beforeRouteUpdate(to, from, next) {
    let params = this.getParams(to);

    EventBus.$emit(params.event, params);

    next();
  },

  methods: {
    getParams(route) {
      let path = route.path;
      let url  = route.path || '';

      let routeName = route.name || '';

      let event  = '';
      let params = {};

      if(path === '/') {
        event = 'loadMainPage';
      }
      else if(path === '/menyu') {
        event = 'loadMenuPage';
      }
      else if(path === '/o-zavedenii') {
        event = 'loadAboutPage';
      }
      else if(path === '/fotootchety') {
        event = 'loadPhotoReportsPage';
      }
      else if(path === '/anonsy') {
        event = 'loadAdvertisementPage';
      }
      else if(path === '/3d-tur') {
        event = 'loadTourPage';
      }
      else if(path === '/otzivy') {
        event = 'loadReviewsPage';
      }
      else if(path === '/kontakty') {
        event = 'loadContactsPage';
      }
      else if(path === '/politika-konfidencialnosti') {
        event = 'loadPrivacyPolicyPage';
      }
      else if(path === '/nashy-zavedeniya') {
        event = 'loadRestaurantsPage';
      }
      else if(path === '/oplata-po-karte-sberbanka') {
        event = 'loadCardPaymentPage';
      }
      else if(path === '/rekvizity-kompanii') {
        event = 'loadCompanyDetailsPage';
      }
      else {
        event = 'load404Page';
      }

      // Name

      if(routeName === 'Cart' || routeName === 'CartStep') {
        event = 'loadCartPage';
        params.params = route.params || {};
      }
      else {
        EventBus.$emit('resetFirstReq');
      }

      if(routeName === 'MenuInside') {
        event = 'loadMenuPageInside';
        params.params = route.params || {};
      } else {
        EventBus.$emit('resetMenuPage');
      }

      if(routeName === 'PhotoReportsInside') {
        event         = 'loadPhotoReportsPageInside';
        params.params = route.params || {};
      }

      if(routeName === 'AdvertisementInside') {
        event         = 'loadAdvertisementPageInside';
        params.params = route.params || {};
      }

      params.event = event || '';
      params.url   = url;

      return params;
    }
  }
}
</script>
